// extracted by mini-css-extract-plugin
export default {"votingGrid":"VotingGrid_votingGrid__zzq3C","votingScore":"VotingGrid_votingScore__TA00-"};